const de = {
  // Navbar
  nav_home: "Startseite",
  nav_about: "\u00dcber Tenten-Ojisan",
  nav_services: "Leistungen & Preise",
  nav_flow: "So funktioniert es",
  nav_testimonials: "Erfahrungsberichte",
  nav_faq: "H\u00e4ufige Fragen",
  nav_contact: "Kontakt",
  nav_cta: "Lesung buchen",
  nav_subtitle: "Namenslesung \u00b7 Okinawa",
  nav_title: "Tenten-Ojisan Wahrsagung",

  // Hero
  hero_headline1: "Auf einer stillen Insel",
  hero_headline2: "in Okinawa",
  hero_headline3: "h\u00f6rt er die Stimme",
  hero_headline4: "Ihres Namens.",
  hero_body: "Eine beliebte Namenslesung mit monatelanger Wartezeit.\nJeden Monat reise ich in Ihrem Namen zur Insel\nund \u00fcberbringe Ihren Namen pers\u00f6nlich dem Meister.",
  hero_pill1: "Keine Namenswechsel n\u00f6tig",
  hero_pill2: "100% online",
  hero_pill3: "Lieferung innerhalb 1 Monats",
  hero_pill4: "Erste 100 pro Monat",
  hero_btn_apply: "Lesung buchen",
  hero_btn_services: "Leistungen ansehen",
  hero_scroll: "SCROLLEN",

  // About
  about_heading: "\u00dcber Tenten-Ojisan",
  about_intro: "Auf der ruhigen Insel \u003cstrong\u003eIkei-jima\u003c/strong\u003e, umh\u00fcllt vom sanften Meer Okinawas,\ngibt es einen Mann, der jedem Namen still etwas Licht hinzuf\u00fcgt.\nDie Menschen nennen ihn liebevoll \u003cstrong\u003e\u201eTenten-Ojisan\u201c\u003c/strong\u003e.",
  about_block1_label: "Vom Banker zum Namensleser",
  about_block1_text: "Tenten-Ojisan war urspr\u00fcnglich Banker.\nDurch seinen Einsatz wurde er der \u003cstrong\u003ej\u00fcngste Filialleiter\u003c/strong\u003e seines Unternehmens.\nBei der Arbeit mit vielen Menschen entstand eine Frage in seinem Herzen.",
  about_block1_quote: "\u201eWarum scheinen manche Menschen R\u00fcckenwind zu haben, obwohl alle gleich hart arbeiten?\u201c",
  about_block1_sub: "Diese kleine Frage wurde zum Beginn einer gro\u00dfen Entdeckungsreise.",
  about_block2_label: "Altes Wissen und eine stille Offenbarung",
  about_block2_text: "Er widmete jede freie Minute dem Studium alter Namenslesetexte und erforschte sorgf\u00e4ltig die Strichanzahl traditioneller Zeichen und den Klangfluss.",
  about_block2_text2: "Er erkannte, dass \u003cstrong\u003e\u201eTen-ten (Stimmzeichen) den Fluss eines Namens still harmonisieren k\u00f6nnen.\u201c\u003c/strong\u003e",
  about_block2_sub: "Es war keine dramatische Magie oder eine auff\u00e4llige Erfolgsformel,\nsondern ein sanfter Weg, das Licht, das bereits in einer Person vorhanden ist, sichtbarer zu machen.",
  about_block3_label: "Mundpropaganda \u2013 jetzt 6 Monate Wartezeit",
  about_block3_text: "Seine sanften Lesungen verbreiteten sich rein durch Mundpropaganda, und nun \u003cstrong\u003ekommen Anfragen aus ganz Japan\u003c/strong\u003e.\nOb ber\u00fchmt oder nicht \u2013 er behandelt jeden Menschen mit der gleichen Sorgfalt.\nEr legt seine Hand auf jeden Namen und begleitet das Leben dieser Person.\nDas ist der Stil von Tenten-Ojisan.",

  // Gallery
  gallery_heading: "Galerie",
  gallery_sub: "Okinawa \u00b7 Insel Ikei",

  // Services
  services_heading: "Leistungen & Preise",
  services_note1: "\u203b Alle Geb\u00fchren beinhalten das Honorar des Meisters und unseren Vor-Ort-Vertretungsservice.",
  services_note2: "\u203b Keine zus\u00e4tzlichen Kosten. Vertrauen Sie uns gerne.",
  services_tab1: "Pers\u00f6nlicher Name",
  services_tab2: "Gesch\u00e4ftsname",
  services_tab3: "Tiername",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "Wir beobachten sanft Wachstum, Umgebung und Herzensregungen und f\u00fcgen das perfekte Ten-ten f\u00fcr Sie hinzu.",
  services_tab2_desc: "Ein sanfter R\u00fcckenwind f\u00fcr neue Herausforderungen. Den Fluss Ihres Unternehmens sanft harmonisieren.",
  services_tab3_desc: "F\u00fcr das Familienmitglied, das immer an Ihrer Seite ist. Wir liefern einen Namen voller Frieden und W\u00e4rme.",
  services_row1_target1: "Ab 16 Jahre",
  services_row1_target2: "4\u201315 Jahre",
  services_row1_target3: "0\u20133 Jahre",
  services_row2_target1: "Gesch\u00e4ft / Unternehmen / Gesch\u00e4ftsname",
  services_row3_target1: "Tiername",
  services_col_target: "Zielgruppe",
  services_col_price: "Preis (inkl. MwSt.)",
  services_cta: "Diesen Service anfragen",
  services_includes_title: "Was enthalten ist (alles im Preis)",
  services_inc1: "Namenslesung",
  services_inc2: "Optimaler Ten-ten-Vorschlag",
  services_inc3: "Visitenkartenformat-Karte auf Wunsch per Post (kostenlos)",
  services_inc4: "Ratschl\u00e4ge f\u00fcr gutes Gl\u00fcck",
  services_inc5: "Digitales Foto der Namenskarte",
  services_includes_note: "Eine Lesung, um den Charme, der bereits in Ihrem Namen steckt, sanft hervorzuheben.",
  services_payment_title: "Zahlung",
  services_payment_method: "Bankweisung (Vorauszahlung)",
  services_payment_desc: "Wir teilen Ihnen die Bankdaten nach Ihrer Anfrage mit.\nSobald Ihre Zahlung abgeschlossen ist, beginnt der Gl\u00fccksfluss still, sich auszurichten.",
  services_first_title: "F\u00fcr Erstbesucher",
  services_first_desc: "Es ist nat\u00fcrlich, sich unsicher zu f\u00fchlen.\nDieses Gef\u00fchl ist ein Signal Ihres Herzens,\ndass es Zeit ist, eine sanfte Ver\u00e4nderung zu beginnen.",
  services_first_cta: "Mit einer Beratung beginnen",

  // Flow
  flow_heading: "So funktioniert es",
  flow_step1_title: "Anfrageformular einreichen",
  flow_step1_c1: "Bitte f\u00fcllen Sie die erforderlichen Informationen im daf\u00fcr vorgesehenen Formular aus.",
  flow_step1_c2: "Nach dem Absenden erhalten Sie innerhalb von 2\u20133 Werktagen eine Antwort-E-Mail.",
  flow_step1_c3: "Die E-Mail enth\u00e4lt die n\u00e4chsten Schritte und Anweisungen zur Bankweisung.",
  flow_step2_title: "Lesegeb\u00fchr \u00fcberweisen",
  flow_step2_c1: "Bitte \u00fcberweisen Sie die Lesegeb\u00fchr auf das in der Antwort-E-Mail angegebene Konto.",
  flow_step2_c2: "Nach Best\u00e4tigung beginnen wir, Ihre Lesung der Reihe nach vorzubereiten.",
  flow_step3_title: "Uns \u00fcber Ihre \u00dcberweisung informieren",
  flow_step3_c1: "Senden Sie nach der \u00dcberweisung ein Foto Ihres Belegs an die in der E-Mail angegebene Adresse.",
  flow_step3_c2: "Nach Best\u00e4tigung senden wir Ihnen eine Nachricht \u201eRegistrierung abgeschlossen\u201c.",
  flow_step3_note: "Ohne diese Benachrichtigung k\u00f6nnen wir Ihre Lesung m\u00f6glicherweise nicht beginnen. Bitte senden Sie sie unbedingt.",
  flow_step4_title: "Leseergebnisse erhalten",
  flow_step4_c1: "Innerhalb von etwa einer Woche nach der Lesung senden wir Ihnen per E-Mail ein Foto Ihrer Namenskarte mit Ten-ten.",
  flow_step4_c2: "Anschlie\u00dfend senden wir einen detaillierten Lesebericht und Gl\u00fccksratschl\u00e4ge per E-Mail.",
  flow_step5_title: "Namenskarte versenden (optional)",
  flow_step5_c1: "Auf Wunsch versenden wir eine vom Meister handgeschriebene Karte im Visitenkartenformat.",
  flow_step5_c2: "Bitte geben Sie Ihre genaue Postadresse im Adressfeld des Anfrageformulars an.",
  flow_step5_note: "Wenn Sie die Karte nicht ben\u00f6tigen, gen\u00fcgt die Angabe Ihrer Stadt.",
  flow_banner_title: "Vollst\u00e4ndig online. Von \u00fcberall in Japan.",
  flow_banner_desc: "Keine Reise zur Insel Ikei in Okinawa n\u00f6tig.\nSie k\u00f6nnen so beginnen, wie Sie sind, ohne Ihren Alltag zu \u00e4ndern.",
  flow_banner_cta: "Jetzt anfragen",

  // Testimonials
  testimonials_heading: "Erfahrungsberichte",
  testimonials_viewing: "Wird angezeigt",

  // FAQ
  faq_heading: "H\u00e4ufig gestellte Fragen",
  faq_cta_title: "Noch Fragen?",
  faq_cta_desc: "Auch kleine Dinge sind willkommen.\nDie Fragen, die Sie z\u00f6gern zu stellen, sind genau die, die wir h\u00f6ren m\u00f6chten.",
  faq_cta_btn: "Fragen Sie uns gerne",

  // CTA Banner
  cta_heading1: "Kostenlose",
  cta_heading2: "Beratung",
  cta_btn: "Jetzt buchen",

  // Contact
  contact_heading: "Kontakt",
  contact_desc: "Kontaktieren Sie uns \u00fcber dieses Formular f\u00fcr Leseanfragen oder Fragen. Wir antworten in der Regel innerhalb von 2\u20133 Werktagen.",
  contact_address_label: "Adresse",
  contact_address_value: "Tochigi, Japan (Online \u00b7 Landesweit)",
  contact_email_label: "E-Mail",
  contact_hours_label: "Zeiten",
  contact_hours_value: "Werktags 9:00\u201318:00 Uhr (Sa/So/Feiertage geschlossen)",
  contact_note_title: "\u00dcber Antworten",
  contact_note_desc: "Unsere Antwort k\u00f6nnte in Ihrem Spam-Ordner landen.\nWenn Sie nach 2\u20133 Werktagen keine Antwort erhalten haben, kontaktieren Sie uns bitte direkt per E-Mail.",
  contact_field_name: "Vollst\u00e4ndiger Name",
  contact_field_furigana: "Furigana (Lesung)",
  contact_field_email: "E-Mail-Adresse",
  contact_field_phone: "Telefonnummer",
  contact_field_service: "Gew\u00fcnschter Service",
  contact_field_message: "Nachricht",
  contact_placeholder_name: "Max Mustermann",
  contact_placeholder_furigana: "\u30e4\u30de\u30c0 \u30bf\u30ed\u30a6",
  contact_placeholder_email: "beispiel@email.com",
  contact_placeholder_phone: "+49 000 00000000",
  contact_placeholder_message: "Bitte geben Sie den Namen ein, den Sie lesen lassen m\u00f6chten, oder Ihre Fragen und W\u00fcnsche.",
  contact_select_placeholder: "Bitte w\u00e4hlen",
  contact_service1: "Pers\u00f6nlicher Name",
  contact_service2: "Gesch\u00e4ftsname",
  contact_service3: "Tiername",
  contact_service4: "Sonstiges / Beratung",
  contact_submit: "Absenden",
  contact_submitting: "Wird gesendet...",
  contact_privacy: "Eingereichte pers\u00f6nliche Daten werden nur f\u00fcr Leseleistungen verwendet.",
  contact_error: "Senden fehlgeschlagen. Bitte versuchen Sie es sp\u00e4ter erneut oder kontaktieren Sie uns direkt per E-Mail.",
  contact_err_name: "Bitte geben Sie Ihren Namen ein",
  contact_err_email_required: "Bitte geben Sie Ihre E-Mail-Adresse ein",
  contact_err_email_invalid: "Bitte geben Sie eine g\u00fcltige E-Mail-Adresse ein",
  contact_err_service: "Bitte w\u00e4hlen Sie einen Service",
  contact_err_message_required: "Bitte geben Sie Ihre Nachricht ein",
  contact_err_message_limit: "Bitte begrenzen Sie Ihre Nachricht auf 500 Zeichen",
  contact_thanks_title: "Nachricht gesendet",
  contact_thanks_desc: "Vielen Dank f\u00fcr Ihre Kontaktaufnahme.\nWir werden Ihre Nachricht pr\u00fcfen und innerhalb von \u003cstrong\u003e2\u20133 Werktagen\u003c/strong\u003e antworten.\nBitte haben Sie einen Moment Geduld.",
  contact_thanks_check1: "Bitte pr\u00fcfen Sie Ihre Best\u00e4tigungs-E-Mail",
  contact_thanks_check2: "Pr\u00fcfen Sie auch Ihren Spam-Ordner",
  contact_thanks_check3: "Bitte rechnen Sie mit 2\u20133 Werktagen f\u00fcr eine Antwort",
  contact_thanks_another: "Eine weitere Nachricht senden",

  // Footer
  footer_subtitle: "Namenslesung \u00b7 Okinawa",
  footer_title: "Tenten-Ojisan Wahrsagung",
  footer_desc: "Von Okinawa in ganz Japan. Ein Namenslesemeister mit \u00fcber 50 Jahren Erfahrung liest sorgf\u00e4ltig das Schicksal in Ihrem Namen.",
  footer_contact_title: "KONTAKTINFORMATIONEN",
  footer_address_label: "ADRESSE",
  footer_address_value: "Tochigi, Japan\n(Online \u00b7 Landesweit)",
  footer_email_label: "E-MAIL",
  footer_hours_label: "ZEITEN",
  footer_hours_value: "Werktags 9:00\u201318:00 Uhr\n(Sa/So/Feiertage geschlossen)",
  footer_nav_title: "NAVIGATION",
  footer_copyright: "\u00a9 2025 Tenten-Ojisan Wahrsagung. Alle Rechte vorbehalten.",
  footer_privacy: "Datenschutzrichtlinie",
  footer_law: "Gesetz \u00fcber spezifizierte Handelsgesch\u00e4fte",
  footer_sitemap: "Sitemap",
};

export default de;
